<template>
  <div class="ai-stat" :class="tone">
    <div class="ai-stat-rule"></div>
    <div class="ai-stat-top">
      <span class="ai-stat-icon" v-if="icon">{{ icon }}</span>
      <span class="ai-stat-label">{{ label }}</span>
    </div>
    <div class="ai-stat-value">
      <span v-if="prefix" class="ai-stat-affix">{{ prefix }}</span>{{ display }}<span v-if="suffix" class="ai-stat-affix">{{ suffix }}</span>
    </div>
    <div class="ai-stat-note" v-if="note">{{ note }}</div>
  </div>
</template>

<script>
export default {
  name: 'AiStatCard',
  props: {
    label: { type: String, default: '' },
    value: { type: [Number, String], default: 0 },
    note: { type: String, default: '' },
    icon: { type: String, default: '' },
    prefix: { type: String, default: '' },
    suffix: { type: String, default: '' },
    tone: { type: String, default: 'neutral' }, // neutral | green | red | amber | blue | primary
  },
  computed: {
    display() {
      return typeof this.value === 'number' ? this.value.toLocaleString() : this.value;
    },
  },
};
</script>

<style scoped>
.ai-stat {
  position: relative;
  background: var(--card, #fff);
  border: 1px solid var(--card-bd, #e9e6f2);
  border-radius: 14px;
  padding: 18px 18px 16px;
  overflow: hidden;
  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
}
.ai-stat:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 26px -12px var(--accent-shadow, rgba(109, 40, 217, .28));
  border-color: var(--accent, #94a3b8);
}
/* colored top rule = state at a glance */
.ai-stat-rule {
  position: absolute; top: 0; left: 0; right: 0; height: 3px;
  background: var(--accent, #a3a3b8);
}
.ai-stat.green   { --accent: #059669; --accent-shadow: rgba(5,150,105,.22); }
.ai-stat.red     { --accent: #e11d48; --accent-shadow: rgba(225,29,72,.22); }
.ai-stat.amber   { --accent: #d97706; --accent-shadow: rgba(217,119,6,.22); }
.ai-stat.blue    { --accent: #e11d2a; --accent-shadow: rgba(225,29,42,.24); }
.ai-stat.primary { --accent: #e11d2a; --accent-shadow: rgba(225,29,42,.24); }
.ai-stat.neutral { --accent: #9a8a8a; --accent-shadow: rgba(120,100,100,.18); }

.ai-stat-top { display: flex; align-items: center; gap: 7px; margin-bottom: 10px; }
.ai-stat-icon { font-size: 14px; line-height: 1; opacity: .9; }
.ai-stat-label {
  font-size: 10.5px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .07em; color: var(--label, #6b6b86);
}
.ai-stat-value {
  font-size: 34px; font-weight: 800; line-height: 1; letter-spacing: -.02em;
  color: var(--num, #1a1730); font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum" 1;
}
.ai-stat.green .ai-stat-value  { color: #059669; }
.ai-stat.red .ai-stat-value    { color: #e11d48; }
.ai-stat.amber .ai-stat-value  { color: #b45309; }
.ai-stat.blue .ai-stat-value   { color: #e11d2a; }
.ai-stat.primary .ai-stat-value { color: #e11d2a; }
.ai-stat-affix { font-size: 20px; font-weight: 700; opacity: .55; margin: 0 1px; }
.ai-stat-note { font-size: 11px; color: var(--note, #9a97ad); margin-top: 8px; line-height: 1.5; }

/* amber (fees) gets a faint tinted ground so money reads differently */
.ai-stat.amber { background: linear-gradient(180deg, rgba(255,251,235,.9), rgba(254,243,199,.35)); border-color: #f6e4bf; }
</style>
